const data = [
  {
    nameOfQuestion: 'name',
    question: 'What is your Name?',
    placeholder: 'e.g. John Doe'
  },
  {
    nameOfQuestion: 'pronoun',
    question: 'What are your pronouns?',
    enum: ['he/him', 'she/her', 'they/them']
  },
  {
    nameOfQuestion: 'greeting',
    question: 'What is your preferred greeting?',
    enum: ['Dear', 'Attention:', 'Hello']
  },
    
  {
    nameOfQuestion: 'email',
    question: 'What is your email?',
    placeholder: 'e.g. sam@sam.com'
  },
    
  {
    nameOfQuestion: 'companyName',
    question: 'What is the company\'s name?',
    placeholder: 'e.g. Adobe'
  },
  {
    nameOfQuestion: 'hiringManager',
    question: 'Who is the hiring manager?',
    placeholder: 'e.g. John Doe'
  },
  {
    nameOfQuestion: 'companyAddress',
    question: 'What is the company\'s address?',
    placeholder: 'e.g. 345 Park Avenue San Jose, CA 95110-2704'
  },
  {
    nameOfQuestion: 'companyMission',
    question: 'What is the company\'s mission statement?',
    placeholder: 'e.g. To change the world with software and data'
  },
  {
    nameOfQuestion: 'departmentName',
    question: 'What department are you applying for?',
    placeholder: 'e.g. Engineering'
  },
  {
    nameOfQuestion: 'jobKeyWord1',
    question: 'What is one key word from the job description?',
    placeholder: 'e.g. Collaborative'
  }
  ,
  {
    nameOfQuestion: 'jobKeyWord2',
    question: 'What is another key word from the job description?',
    placeholder: 'e.g. Agile'
  }
  ,
  {
    nameOfQuestion: 'jobKeyWord3',
    question: 'What is a third key word from the job description?',
    placeholder: 'e.g. Tech Savvy'
  }
  ,
  {
    nameOfQuestion: 'positionTitle',
    question: 'What is the position you are applying for?',
    placeholder: 'e.g. Software Developer'
  }
  ,
  {
    nameOfQuestion: 'passion1',
    question: 'What is one of your passions?',
    placeholder: 'e.g. Photography'
  }
  ,
  {
    nameOfQuestion: 'passion2',
    question: 'What is another passion?',
    placeholder: 'e.g. Helping People'
  }
  ,
  {
    nameOfQuestion: 'passion3',
    question: 'Name a third passion.',
    placeholder: 'e.g. Drawing'
  },
  {
    nameOfQuestion:'skillJobDescription1',
    question:'What is a skill you have that the job requires?',
    placeholder:'e.g. time management'
  },
  {
    nameOfQuestion:'skillJobDescription2',
    question:'What is another skill you have that the job requires?',
    placeholder:'e.g. problem solving'
  },
  {
    nameOfQuestion:'skillJobDescription3',
    question:'What is a skill you have that the job requires?',
    placeholder:'e.g.emotional intelligence'
  },
  {
    nameOfQuestion:'whyLikeCompany',
    question:'Why do you like this company?',
    placeholder:'e.g.Community involvement'
  },
  {
    nameOfQuestion:'somethingYouLove',
    question:'What is something you love?',
    placeholder:'e.g. baby yoda'
  },
  {
    nameOfQuestion:'value1',
    question:'List one of your values.',
    placeholder:'e.g. integrity'
  },
  {
    nameOfQuestion:'value2',
    question:'List another one of your values.',
    placeholder:'e.g. trustworthiness'
  },
  {
    nameOfQuestion:'value3',
    question:'Name a third value.',
    placeholder:'e.g. responsibility'
  },
  {
    nameOfQuestion:'lifeExperienceRelatedValues',
    question:'Tell me about a time when you demonstrated one of those values?',
    placeholder:'e.g. I saved a puppy.'
  },
  {
    nameOfQuestion:'communityService',
    question:'Is the organization a part of any community service? If so, what?',
    placeholder:'e.g. The Humane Society'
  },
  {
    nameOfQuestion:'companyCustomer',
    question:'Who are the company\'s target customers?',
    placeholder:'e.g. everyday people'
  },
  {
    nameOfQuestion:'whyCustomerMatters',
    question:'Why are those customers close to your heart?',
    placeholder:'e.g.creates equity'
  },
  {
    nameOfQuestion:'companyMotivatesMeTo',
    question:'If hired, what would you be motivated to do?',
    placeholder:'e.g.plant trees'
  },
  {
    nameOfQuestion:'opportunitiesTheEmployerProvides1',
    question:'What opportunities does this company offer it\'s employees?',
    placeholder:'e.g. beer on tap'
  },
  {
    nameOfQuestion:'techLanguage1',
    question:'List a technical languages/skill you know?',
    placeholder:'e.g. React'
  },
  {
    nameOfQuestion:'techLanguage2',
    question:'List a second technical languages/skill you know?',
    placeholder:'e.g. Node.js'
  },
  {
    nameOfQuestion:'techLanguage3',
    question:'List a third technical languages/skill you know?',
    placeholder:'e.g. MongoDB'
  },
  {
    nameOfQuestion:'techLanguage4',
    question:'List a forth technical languages/skill you know?',
    placeholder:'e.g. Express'
  },
  {
    nameOfQuestion:'pastExperience',
    question:'What was your last job?',
    placeholder:'e.g.'
  },
  {
    nameOfQuestion:'pastAccomplishment1',
    question:'What is a major past accomplishment?',
    placeholder:'e.g. Employee of the month'
  },
  {
    nameOfQuestion:'pastAccomplishment2',
    question:'What is another major past accomplishment?',
    placeholder:'e.g. saving money'
  },
  {
    nameOfQuestion: 'sincerely',
    question: 'What is your preferred sign off?',
    enum: ['Sincerely', 'Thank you', 'Best regards', 'Thank you for your consideration']
  }
];

export default data;
